import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from "react-redux";
import Toastmessage from "../../components/Toast";
import { useNavigate } from 'react-router-dom';
import { authApi } from "../../api/api";
import { logout } from "../../features/auth/AuthSlice";
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import { ChevronDown, ChevronUp } from 'react-feather'; // Import Feather icons
import { Divider } from "@mui/material";

const locations = ['GA', 'NY', 'CA'];
const users = ['All', 'User1', 'User2'];
const years = ['2024', '2023', '2022'];
const types = ['Attorneys', 'Paralegals'];

const getColor = (percent) => {
    const value = parseInt(percent);
    return value >= 80 ? 'green' : 'red';
};

const getCellStyle = (value) => {
    let style = {};
    if (typeof value === 'number') {
        if (value > 0) style.color = 'green';
        if (value < 0) style.color = 'red';
    }
    return style;
};

export default function IncentiveReports() {
    const token = useSelector((state) => state.auth.token);
    const userID = useSelector((state) => state.auth.id);
    const [data, setData] = useState([]);
    const [expanded, setExpanded] = useState(null);

    const [locations, setLocations] = useState([]);
    const [users, setUsers] = useState([]);
    const [years, setYears] = useState([]);
    const [types, setTypes] = useState([]);

    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);



    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        fetchYear();
        fetchDesignation();
        fetchUser();
        fetchLocation();
        fetcManageReport(selectedDesignation, selectedUser, selectedLocation, selectedYear);
    }, []);





    const handleDesignationChange = (event, newValue) => {
        setSelectedDesignation(newValue);
        fetcManageReport(newValue, selectedUser, selectedLocation, selectedYear)
    };

    const handleUserChange = (event, newValue) => {
        setSelectedUser(newValue);
        fetcManageReport(selectedDesignation, newValue, selectedLocation, selectedYear)

    };

    const handleLocationChange = (event, newValue) => {
        setSelectedLocation(newValue);
        fetcManageReport(selectedDesignation, selectedUser, newValue, selectedYear)

    };

    const handleYearChange = (event, newValue) => {
        setSelectedYear(newValue);
        fetcManageReport(selectedDesignation, selectedUser, selectedLocation, newValue)
    };


    // Define fetchLocations separately to reuse it
    const fetchYear = async () => {
        const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
        const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setYears(data.year);
                // setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // Define fetchLocations separately to reuse it
    const fetchDesignation = async () => {
        const input_token = 'DESIGNATION'; // Replace with your actual token
        const apiUrl = 'list_of_designation'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.designations.map(location => ({
                    id: location.id,
                    name: location.designation_name, // Match `getOptionLabel`
                }));
                setTypes(statesArray)

                // setLocationOptions(statesArray);
                // setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // Define fetchLocations separately to reuse it
    const fetchUser = async () => {
        const input_token = 'ALL_EMPLOYEES'; // Replace with your actual token
        const apiUrl = 'list_of_all_employee'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.clients.map(location => ({
                    id: location.id,
                    name: location.full_name, // Match `getOptionLabel`
                    initial: location.initial
                }));

                setUsers(statesArray)

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };



    // Define fetchLocations separately to reuse it
    const fetchLocation = async () => {
        const input_token = 'LOCATIONS'; // Replace with your actual token
        const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.locations.map(location => ({
                    id: location.id,
                    locationname: location.location_name, // Match `getOptionLabel`
                }));
                setLocations(statesArray)
                // setLocationOptions(statesArray);
                // setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const fetcManageReport = async (Designation, user, location, year) => {
        const input_token = 'MANAGEMENT_REPORT';
        const apiUrl = 'management_report';

        const dataInput = {
            login_user_id: userID,
            year: year,
            designation: Designation?.id || null,
            user: user?.initial || null,
            location: location?.id || null,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setData(data?.yearly_report);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const handleExpandClick = (index) => {
        setExpanded(expanded === index ? null : index);
    };

    return (
        <Box className="scorecard-container" padding={2}>
            <Box sx={{ width: '100%', padding: 2, backgroundColor: 'var(--theme-bg-light)', borderRadius: 2, }}>
                <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
                    Management Reports
                </Typography>
                <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                    <Grid item size={2}>
                        <Typography>
                            Designation
                        </Typography>
                        <Autocomplete
                            options={types}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} placeholder="Select Designation" />}
                            value={selectedDesignation}
                            onChange={handleDesignationChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid item size={2}>
                        <Typography>
                            User
                        </Typography>
                        <Autocomplete
                            options={users}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} placeholder="Select User" />}
                            value={selectedUser}
                            onChange={handleUserChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid item size={2}>
                        <Typography>
                            Location
                        </Typography>
                        <Autocomplete
                            options={locations}
                            getOptionLabel={(option) => option.locationname}
                            renderInput={(params) => <TextField {...params} placeholder="Select Location" />}
                            value={selectedLocation}
                            onChange={handleLocationChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid item size={2}>
                        <Typography>
                            Year
                        </Typography>
                        <Autocomplete
                            options={years}
                            getOptionLabel={(option) => option.toString()}
                            renderInput={(params) => <TextField {...params} placeholder="Select Year" />}
                            value={selectedYear}
                            onChange={handleYearChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                </Grid>

                <div>
                    <Typography variant="h6" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
                        Staff List
                    </Typography>
                    {data.length === 0 ? (
                        <Typography variant="body1" sx={{ color: 'var(--primary-color)', fontWeight: '600' }}>
                            Report not found
                        </Typography>
                    ) : (
                        data.map((entry, entryIndex) => (
                            <Box key={entryIndex} mb={2} border={1} borderColor="grey.300" borderRadius={2}>
                                <Grid container spacing={2} p={3} alignItems="center">
                                    <Grid item size={2}>
                                        <Typography variant="body1" sx={{ marginBottom: 1.3, color: 'var(--lable-color)' }}>
                                            Name
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'var(--primary-color)', fontWeight: '600' }}>
                                            {entry.title}
                                        </Typography>
                                    </Grid>
                                    <Grid item size={2}>
                                        <Typography variant="body1" sx={{ marginBottom: 1.3, color: 'var(--lable-color)' }}>
                                            Percent Complete%
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: getColor(entry.percent_complete), fontWeight: '600' }}>
                                            {entry.percent_complete}
                                        </Typography>
                                    </Grid>
                                    <Grid item size={2}>
                                        <Typography variant="body1" sx={{ marginBottom: 1.3, color: 'var(--lable-color)' }}>
                                            Collection %
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: getColor(entry.percent_complete), fontWeight: '600' }}>
                                            {entry.collection}
                                        </Typography>
                                    </Grid>
                                    <Grid item size={2}>
                                        <Typography variant="body1" sx={{ marginBottom: 1.3, color: 'var(--lable-color)' }}>
                                            Bonus Earned
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'var(--primary-color)', fontWeight: '600' }}>
                                            {entry.total_bonus}
                                        </Typography>
                                    </Grid>
                                    <Grid item size={2}>
                                        <Typography variant="body1" sx={{ marginBottom: 1.3, color: 'var(--lable-color)' }}>
                                            Last bonus paid on
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'var(--primary-color)', fontWeight: '600' }}>
                                            {entry.paid_on}
                                        </Typography>
                                    </Grid>
                                    <Grid item size={2} display={'flex'} justifyContent={'flex-end'}>
                                        <IconButton onClick={() => handleExpandClick(entryIndex)}>
                                            {expanded === entryIndex ? <ChevronUp /> : <ChevronDown />}
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Collapse in={expanded === entryIndex} timeout="auto" unmountOnExit>
                                    <Divider px={1} sx={{ borderColor: '#777' }} />
                                    <Box padding={2}>
                                        <table style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    {entry.months.map((month, index) => (
                                                        <th key={index}>{month}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {entry.rows.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {row.isHeader ? (
                                                            <td colSpan={entry.months.length + 1} className="section-header">
                                                                {row.label}
                                                            </td>
                                                        ) : (
                                                            <>
                                                                <td>{row.label}</td>
                                                                {row.values.map((value, valueIndex) => (
                                                                    <td key={valueIndex} style={getCellStyle(value)}>
                                                                        {value}
                                                                    </td>
                                                                ))}
                                                            </>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Box>
                                </Collapse>
                            </Box>
                        ))
                    )}
                </div>
            </Box>
        </Box>
    );
}

